import Routing from "./Routing";
import React from "react";
import LoaderHelper from "./customComponent/Loading/LoaderHelper";
import Loading from "./customComponent/Loading";
import { ProfileProvider } from "./context/ProfileProvider";

function App() {
  return (
    <>
    <ProfileProvider>
      <Routing />
      <Loading ref={ref => LoaderHelper.setLoader(ref)} />
    </ProfileProvider>
    </>
  );
}

export default App;
